import React, { useState } from "react";
import "./StakeForm.css";
import { ethers } from "ethers";

const StakeForm = ({ contract, handleStake }) => {
  const [amount, setAmount] = useState("");
  const [duration, setDuration] = useState("");

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handleDurationChange = (e) => {
    setDuration(e.target.getAttribute("data-duration"));
  };

  const onSubmit = async () => {
    if (!amount || !duration) {
      alert("Please enter an amount and select a duration.");
      return;
    }

    try {
      await handleStake(amount, duration);
    } catch (error) {
      console.error("An error occurred during submission:", error);
    }
  };

  return (
    <div className="stake-form">
      <div>
        <h2>Amount to Stake :</h2>
        <input
          type="number"
          value={amount}
          onChange={handleAmountChange}
          placeholder="Enter Amount of INFINITY to Stake"
        />
        <h2>Select Duration :</h2>
        <div className="select-duration">
          <ul>
            <div className="div">
              <li
                data-duration="1"
                onClick={handleDurationChange}
                className={duration === "1" ? "active" : ""}
              >
                1 Month (13% APY)
              </li>
              <li
                data-duration="3"
                onClick={handleDurationChange}
                className={duration === "3" ? "active" : ""}
              >
                3 Months (23% APY)
              </li>
            </div>
            <div>
              <li
                data-duration="6"
                onClick={handleDurationChange}
                className={duration === "6" ? "active" : ""}
              >
                6 Months (33% APY)
              </li>
              <li
                data-duration="12"
                onClick={handleDurationChange}
                className={duration === "12" ? "active" : ""}
              >
                12 Months (43% APY)
              </li>
            </div>
          </ul>
        </div>
      </div>
      <div className="actions">
        <button className="stake" onClick={onSubmit}>
          STAKE
        </button>
      </div>
    </div>
  );
};

export default StakeForm;
